import type { FC } from 'react';
import { Button, Spinner } from '@selfinspectionorg/ui-kit';
import colors from '@selfinspectionorg/ui-kit/css/colors.module.scss';
import { useAccountSwitch, type AccountSwitchParams } from '../../features/switch';
import styles from './SwitchView.module.scss';
import { Card } from '@/components/ui';

type Props = AccountSwitchParams;

export const SwitchView: FC<Props> = ({ userId, locationId, returnUrl }) => {
  const { status, error, dismiss } = useAccountSwitch({ userId, locationId, returnUrl });

  if (status === 'error') {
    return (
      <Card className={styles.wrapper}>
        <Card.Title title="Unable to switch account" description={error ?? undefined} />
        <Button width="100%" onClick={dismiss} data-testid="switch-error-dismiss-button">
          Go back
        </Button>
      </Card>
    );
  }

  // Bootstrapping the session and issuing the switch: a full-height spinner until we either adopt
  // and redirect, or surface an error.
  return (
    <Card className={styles.wrapper}>
      <div className={styles.loader} data-testid="switch-loading">
        <Spinner color={colors.selfInspection_600} width={40} height={40} />
        <p className={styles.text}>Switching account…</p>
      </div>
    </Card>
  );
};
